import { useAppContext } from 'providers/AppProvider';
import { toast, ToastPosition } from 'react-toastify';

const pos = { position: 'top-right' as ToastPosition };

export const successNotification = (msg: string) => {
  const theme = localStorage.getItem('theme') || 'light';

  // alert(msg);
  toast.success(msg, { theme, position: pos.position });
};

export const errorNotification = (msg: string) => {
  const theme = localStorage.getItem('theme') || 'light';

  // alert(msg);
  toast.error(msg, { theme, position: pos.position });
};

export const warningNotification = (msg: string) => {
  const theme = localStorage.getItem('theme') || 'light';
  // alert(msg);
  toast.warning(msg, { theme, position: pos.position });
};
